import { render, staticRenderFns } from "./LegalDocsViewer.vue?vue&type=template&id=03f54af3&scoped=true"
import script from "./LegalDocsViewer.vue?vue&type=script&lang=js"
export * from "./LegalDocsViewer.vue?vue&type=script&lang=js"
import style0 from "./LegalDocsViewer.vue?vue&type=style&index=0&id=03f54af3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f54af3",
  null
  
)

export default component.exports